
import ClustrLogo from "@/components/icons/ClustrLogo";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="py-12 px-6 bg-clustr-text text-white">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8">
          <div className="mb-6 md:mb-0">
            <ClustrLogo width={180} height={54} className="text-white" />
          </div>
          <div className="flex space-x-6">
            <Link to="/releases" className="hover:text-clustr-blue transition-colors">Release Notes</Link>
            <Link to="/intro" className="hover:text-clustr-blue transition-colors">Intro to Clustr</Link>
            <Link to="/workflow" className="hover:text-clustr-blue transition-colors">Workflow</Link>
            <Link to="/roadmap" className="hover:text-clustr-blue transition-colors">Roadmap</Link>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm opacity-75 mb-4 md:mb-0">
            © {new Date().getFullYear()} Clustr. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm">
            <Link to="/privacy-policy" className="opacity-75 hover:opacity-100 transition-opacity">Privacy Policy</Link>
            <Link to="/terms" className="opacity-75 hover:opacity-100 transition-opacity">Terms</Link>
            <Link to="/cookies" className="opacity-75 hover:opacity-100 transition-opacity">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
